module.exports = __webpack_public_path__ + "img/fullscreen.2a311f1a.svg";